import { render } from "./UsersCrud.vue?vue&type=template&id=316bd102&scoped=true"
import script from "./UsersCrud.vue?vue&type=script&lang=js"
export * from "./UsersCrud.vue?vue&type=script&lang=js"

import "./UsersCrud.vue?vue&type=style&index=0&id=316bd102&scoped=true&lang=scss"

import exportComponent from "C:\\Work2022\\300_NEVTER\\500_DEVEL\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316bd102"]])

export default __exports__